export default __webpack_public_path__ + "static/7-6d101f54f4b9b9f4c71cd69bd3cc9b42.png";